
/** Hook para manejo de cookies */
const useCookies = (props) => {
  
  const getCookieValue = (cookie) => {
    return document.cookie.split(";").find((row) => row.trim().startsWith(`${cookie}=`))?.split("=")[1];
  }

  const setCookieValue = (cookie, value) => {
    document.cookie = `${cookie}=${value}`;
  }

  /** Retornara el texto formateado */
  return {
    getCookieValue,
    setCookieValue
  };
};

export default useCookies;